module.exports = __webpack_public_path__ + "img/islington_b1.4f508e93.jpg";